import { render, staticRenderFns } from "./ParentsReport.vue?vue&type=template&id=769ce65c"
import script from "./ParentsReport.vue?vue&type=script&lang=js"
export * from "./ParentsReport.vue?vue&type=script&lang=js"
import style0 from "./ParentsReport.vue?vue&type=style&index=0&id=769ce65c&prod&lang=scss"
import style1 from "./ParentsReport.vue?vue&type=style&index=1&id=769ce65c&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports